import { metadataActionHandlers } from './metadata-action-handlers';
import { routerActionHandlers } from './router-action-handlers';
import { ogActionHandlers } from './og-action-handlers';

// export all action handlers as const so we can pass them all at once in the State configuration in main.ts
export const allActionHandlers = [metadataActionHandlers, routerActionHandlers, ogActionHandlers];

export * from './metadata-action-handlers';
export * from './router-action-handlers';
export * from './og-action-handlers';
